import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import AppBadge from '../ui/AppBadge';

/**
 * Carte « À traiter » (compteur + lien).
 */
const PortalTodoCard = ({ item, count }) => {
  const displayCount = count > 99 ? '99+' : String(count);

  return (
    <Link
      to={item.to}
      className="portal-todo-card"
      aria-label={`${item.label} : ${count}`}
    >
      <div className="portal-todo-card__icon">
        <Icon icon={item.icon} />
      </div>
      <div className="portal-todo-card__body">
        <div className="portal-todo-card__title-row">
          <h3 className="portal-todo-card__title mb-0">{item.label}</h3>
          <AppBadge variant="danger" pill className="portal-todo-card__badge">
            {displayCount}
          </AppBadge>
        </div>
        <p className="portal-todo-card__description mb-0">{item.description}</p>
      </div>
      <div className="portal-todo-card__action" aria-hidden>
        <Icon icon="solar:arrow-right-linear" className="text-xl" />
      </div>
    </Link>
  );
};

export default PortalTodoCard;
